/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Port_SelectInputs */

const es_ab_port_select = /** @type {(inputs: Ab_Port_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar puerto`)
};

const gl_ab_port_select = /** @type {(inputs: Ab_Port_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar porto`)
};

const en_ab_port_select = /** @type {(inputs: Ab_Port_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select port`)
};

/**
* | output |
* | --- |
* | "Select port" |
*
* @param {Ab_Port_SelectInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_port_select = /** @type {((inputs?: Ab_Port_SelectInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Port_SelectInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_port_select(inputs)
	if (locale === "en") return en_ab_port_select(inputs)
	return es_ab_port_select(inputs)
});